import {Auth} from "aws-amplify";

export default {
  name: 'AuthService',
  data() {
    return {
      config: {}
    }
  },
  methods: {
    isAuthenticated() {
      return new Promise((resolve) => {
        try {
          // let user = await Auth.currentAuthenticatedUser();
          Auth.currentAuthenticatedUser()
            .then(user => {
              // return Auth.changePassword(user, 'oldPassword', 'newPassword');
              resolve(user);
            })
            .catch(err => {
              console.log(err);
              resolve(null);
            });
          // return user.signInUserSession != null;
        } catch (e) {
          console.log(e);

          resolve(null);
        }
      });
    },
    signOut() {
      try {
        Auth.signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
    },
  },
  created: function () {
  }
}

